import { timelineColors } from "../theme/config";

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 10;

export const PLAYHEAD_WIDTH = 19;
export const TRACK_HEIGHT = 45;

export const TIMELINE_HEIGHT = 95;

export const scrollbarStyle: React.CSSProperties = {
  scrollbarWidth: "thin",
  scrollbarColor: timelineColors.scrollbarTrack,
};
